import React, { useRef } from 'react';

import Icon, { ICON_TYPES } from '../icons';
import Button from '../button/Button';

import styles from './ImagePicker.module.scss';

interface Props {
  profileImgUrl: string;
  onChange: (data: object) => () => void;
}

const ImagePicker = (props: Props) => {
  const { profileImgUrl, onChange } = props;

  const inputRef = useRef<HTMLInputElement>(null);

  const handleAddImage = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    // if (file) {
    //   if (get(file, 'size', 0) > 4000000) {
    //     // toaster('error', 'File size must be less than 4mb');
    //     return;
    //   }
    // }

    // setProfileImgUrl(URL.createObjectURL(file || ({} as File)));

    onChange({
      profile_img: file,
      profile_img_url: URL.createObjectURL(file || ({} as File)),
    })();
  };

  return (
    <div className={styles.ImagePicker}>
      {!profileImgUrl ? (
        <div className={styles.Picker}>
          <div className={styles.user}>
            <Icon icon={ICON_TYPES.USER} />
          </div>
          <div
            className={styles.pickerHover}
            onClick={() => {
              inputRef.current?.click();
            }}>
            <Icon icon={ICON_TYPES.EDITICON} />
          </div>
        </div>
      ) : (
        <div className={styles.image}>
          <img
            src={profileImgUrl || ''}
            alt='profile'
            width={88}
            height={88}
            style={{
              borderRadius: '50%',
            }}
          />
          <div
            className={styles.close}
            onClick={() => {
              onChange({ profile_img: '', profile_img_url: '' })();
            }}>
            <Icon icon={ICON_TYPES.CLOSEICON} />
          </div>
        </div>
      )}

      <input
        type='file'
        accept='image/*'
        className={styles.file}
        ref={inputRef}
        onChange={handleAddImage}
      />

      <div className={styles.right}>
        <p className={styles.firstText}>Set your Profile Picture</p>
        {!profileImgUrl ? (
          <div
            className={styles.Upload}
            onClick={() => {
              inputRef.current?.click();
            }}>
            <Icon icon={ICON_TYPES.DOWNLOAD} />
            <p className={styles.uploadText}>Upload</p>
          </div>
        ) : (
          <Button
            prefixIcon={ICON_TYPES.DOWN}
            type='Outline'
            width='97px'
            onClick={() => {
              inputRef.current?.click();
            }}>
            Edit
          </Button>
        )}
        {/* <p className={styles.description}>(Only .jpeg, .jpg, .png files Supported)</p> */}
      </div>
    </div>
  );
};

export default ImagePicker;
